import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import TextWrapper from './styled/TextWrapper';
import UnsupportedText from './styled/UnsupportedText';

const UnsupportedBrowser = ({ browserName, isDesktop }) => (
  <Fragment>
    <TextWrapper isDesktop={isDesktop}>
      <UnsupportedText>Sorry! italist no longer supports {browserName}.</UnsupportedText>
      <br />
      <UnsupportedText>
        Please upgrade your browser now to access 1,000+ international brands and 200,000+ expertly-curated luxury items
        that are imported from Italy at the best price and delivered to your doorstep.
      </UnsupportedText>
    </TextWrapper>
  </Fragment>
);

UnsupportedBrowser.propTypes = {
  browserName: PropTypes.string,
  isDesktop: PropTypes.bool
};

export default UnsupportedBrowser;
